import React, { useEffect, useState } from 'react';
import { db } from '../firebase/config';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import '../styles/AdminDashboard.css';

const AdminDashboard = () => {
  const [posts, setPosts] = useState([]);

  // Fetch posts from Firestore
  const fetchPosts = async () => {
    const querySnapshot = await getDocs(collection(db, 'posts'));
    const postsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPosts(postsData);
  };

  // Fetch posts when the component mounts
  useEffect(() => {
    fetchPosts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      await deleteDoc(doc(db, 'posts', id));
      // Instead of calling fetchPosts() again, you can just remove the post locally
      setPosts(posts.filter(post => post.id !== id)); // Optimistic UI update
    }
  };

  return (
    <div className="admin-dashboard">
      <Navbar />
      <div className="admin-dashboard-content">
        <h1>Admin Dashboard</h1>
        <Link to="/admin/add">
          <button className="add-post-btn">Add New Post</button>
        </Link>
        <div className="posts-list">
          {posts.length === 0 ? (
            <p>No posts available</p>
          ) : (
            posts.map(post => (
              <div key={post.id} className="post-card">
                <h3>{post.title}</h3>
                <p>{post.content}</p>
                <button className="delete-btn" onClick={() => handleDelete(post.id)}>Delete</button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
